import queryString from 'querystring';
import _ from 'lodash';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
// import axiosObjectPlugin from "../libs/mk-womanizer/axios-action-creator-object-plugin";
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

// let redux = reduxCreator.type('ROOM_MESSAGES').plugin(axiosObjectPlugin);
let redux = reduxCreator.type('ROOM_MESSAGES').plugin(axiosPlugin, {template: "multiArray"});

let fetchRoomAction = redux.fetchActionGet();

export const subscribeRoomMessage = redux.action('SUBSCRIBE', function (roomId, key) {
    return {
        subscribe: {
            path : 'ROOMS_MESSAGES',
            params : {roomId},
            key
        }
    }
});

export const unsubscribeRoomMessage = redux.action('UNSUBSCRIBE', function (key) {
    return {
        unsubscribe: {
            type : redux.types.SUBSCRIBE,
            key
        }
    }
});

redux.reducerForType('SUBSCRIBE_DATA', (state,action) => {
    let newState = {...state};
    let operation = _.get(action, 'payload.op');
    if(operation === "create"){
        let currentRoom = _.get(action, 'payload.roomId');
        if(currentRoom){
            let messagesCurrentRoom = newState[currentRoom].data || [];
            if(!_.find(messagesCurrentRoom, {_id: action.payload._id})) {
                newState[currentRoom].data.unshift(action.payload);
                newState[currentRoom].total++;
            }
        }
    }
    else if(operation === "update"){
        let currentRoom = _.get(action, 'payload.roomId');
        if(currentRoom){
            newState[currentRoom].data = newState[currentRoom].data.map(item => {
                if (item._id.toString() === action.payload._id.toString()) {
                    item = action.payload;
                }
                return item;
            });
        }
    }
    else if(operation === "remove"){
        if(action.payload && action.payload._id){
            let currentRoom = _.get(action, 'payload.roomId');
            if(currentRoom){
                newState[currentRoom].data = newState[currentRoom].data.filter(item => item._id.toString() !== action.payload._id.toString());
                newState[currentRoom].total--;
                if(newState.total < 0){
                    newState[action.payload.roomId].total = 0;
                }
            }
        }
    }
    else if(operation === "updateIsDeleted"){
        if(action.payload && action.payload.roomId){
            let currentRoom = _.get(action, 'payload.roomId');
            if(currentRoom){
                let ids = _.get(action, 'payload.roomMessageIds') || [];
                ids = ids.map(item => item.toString());
                newState[currentRoom].data = newState[currentRoom].data.map(item => {
                    if (ids.includes(item._id.toString())) {
                        item.isDeleted = true;
                    }
                    return item;
                });
            }
        }
    }
    // return newState;
    return newState;
});

export const TYPES = redux.types;
export const fetchRoomMessages = (roomId, query = {}, more = false) => fetchRoomAction(`/rooms/${roomId}/messages?${queryString.stringify(query)}`, null, {
    key: roomId,
    more
});
export const resetRoomMessages = () => redux.actions.reset();
export const roomMessages = redux.reducer();